require('./query-builder.component.scss');

export class QueryBuilderController {

  constructor($scope) {
    this.$scope = $scope;
  }

  $onInit() {
    if (!this.group) {
      this.group = {
        operator: 'AND',
        rules   : [],
      };
    }
  }

}

export const QueryBuilderComponent = {
  bindings  : {
    group: '=',
  },
  template  : require('./query-builder.component.html'),
  controller: QueryBuilderController,
};



// WEBPACK FOOTER //
// ./src/filter/query-builder/query-builder.component.js